import logo_tipddy from "./assets/logo-tipddy.png";
import logoAbastible from "./assets/logoabastible.webp";
import "./index.css";
import { useTheme } from "../../contexts/ThemeContext";
import { useConfig } from "../../contexts/config";
import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { LinkedIn } from "@mui/icons-material";

export const Footer = () => {
  useConfig();
  const theme = useTheme();
  const contrastColorSecondary = "#fff";

  return (
    <>
      {/* <div className="wrapper fon-footer sale-movil" style={theme.styles.nav}>
        <div className="container"> */}
      <div
        style={{ backgroundColor: theme.colors.backgroundColorFooter }}
        className="flex flex-col justify-between items-center tablet:items-end gap-8 tablet:gap-0 px-[3rem] tablet:px-[6rem] tablet:flex-col tablet:p-[4rem] "
      >
        <div className="flex flex-col gap-10 tablet:gap-0 tablet:flex-row tablet:justify-between w-full" style={{ maxWidth: "150rem", margin: "0 auto" }}>
          <div className="flex flex-col tablet:flex-row gap-16 tablet:gap-28">
            <div className="flex flex-col items-center tablet:items-start mb-8">
              <p
                className="text-3xl font-semibold mb-4"
                style={{ color: contrastColorSecondary }}
              >
                Accesos directos
              </p>
              <ul className="!list-none flex flex-col gap-3 [&_a]:mx-0">
                <li>
                  <a
                    href="https://abastible.cl/corporativo/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-2xl hover:underline mx-0"
                    style={{ color: contrastColorSecondary }}
                  >
                    Somos Abastible
                  </a>
                </li>
                <li>
                  <a
                    href="https://abastible.cl/corporativo/noticias/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-2xl hover:underline mx-0"
                    style={{ color: contrastColorSecondary }}
                  >
                    Noticias
                  </a>
                </li>
                <li>
                  <a
                    href="https://abastible.cl/corporativo/sostenibilidad/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-2xl hover:underline mx-0"
                    style={{ color: contrastColorSecondary }}
                  >
                    Sostenibilidad
                  </a>
                </li>
                <li>
                  <a
                    href="https://abastible.cl/gas-cilindro/consejos-y-tips/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-2xl hover:underline mx-0"
                    style={{ color: contrastColorSecondary }}
                  >
                    Consejos y Tips
                  </a>
                </li>
                <li>
                  <a
                    href="https://abastible.cl/gas-cilindro/canal-de-denuncias/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-2xl hover:underline mx-0"
                    style={{ color: contrastColorSecondary }}
                  >
                    Canal de Denuncias
                  </a>
                </li>
              </ul>
            </div>

            {/* Social media column */}
            <div className="flex flex-col items-center tablet:items-start  [&_a]:mx-0">
              <p
                className="text-3xl font-semibold mb-4"
                style={{ color: contrastColorSecondary }}
              >
                Conecta con nosotros
              </p>
              <div className="flex gap-4">
                <a
                  href="https://www.facebook.com/AbastibleCL"
                  target="_blank"
                  rel="noreferrer"
                  className="text-4xl hover:opacity-80"
                >
                  <FacebookIcon
                    style={{ fontSize: "3rem", color: contrastColorSecondary }}
                  />
                </a>
                <a
                  href="https://www.instagram.com/laenergiadevivir"
                  target="_blank"
                  rel="noreferrer"
                  className="text-4xl hover:opacity-80"
                >
                  <InstagramIcon
                    style={{ fontSize: "3rem", color: contrastColorSecondary }}
                  />
                </a>
                <a
                  href="https://www.youtube.com/AbastibleChileSA"
                  target="_blank"
                  rel="noreferrer"
                  className="text-4xl hover:opacity-80"
                >
                  <YouTubeIcon
                    style={{ fontSize: "3rem", color: contrastColorSecondary }}
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/abastible-s.a./"
                  target="_blank"
                  rel="noreferrer"
                  className="text-4xl hover:opacity-80"
                >
                  <LinkedIn
                    style={{ fontSize: "3rem", color: contrastColorSecondary }}
                  />
                </a>
                <a
                  href="https://www.tiktok.com/@abastiblecl"
                  target="_blank"
                  rel="noreferrer"
                  className="text-4xl hover:opacity-80"
                >
                  <svg
                    style={{ color: contrastColorSecondary }}
                    width="3rem"
                    height="3rem"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M16.6 5.82s.51.5 0 0A4.278 4.278 0 0 1 15.54 3h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div className="w-[16rem]  tablet:w-[26rem] h-auto flex self-center tablet:items-center tablet:justify-center  mb-4">
            <img
              src={
                logoAbastible
              }
              alt="Academia Tecnigen Logo"
              className="max-w-full  max-h-[9rem] object-contain"
            />
          </div>
        </div>

        {/* Tipddy attribution - at the bottom */}
        <div className="flex flex-row items-center gap-2 py-4 mt-8 border-t border-gray-700/30 w-full justify-center" style={{ maxWidth: "72rem", margin: "0 auto" }}>
          <img
            src={logo_tipddy}
            alt="Tipddy Logo"
            className="h-6 w-auto object-contain"
          />
          <p
            className="text-2xl font-medium opacity-80 flex items-center"
            style={{ color: contrastColorSecondary }}
          >
            &copy; {new Date().getFullYear()} Powered by Tipddy
          </p>
        </div>
      </div>
    </>
  );
};
